/**
 * Reusable section heading component for landing page sections.
 *
 * Renders a centered heading with an optional subtitle. Supports a
 * `light` variant for use on dark background sections.
 *
 * @module landing/components/SectionHeading
 */

import React from 'react';

export interface SectionHeadingProps {
  /** Section title text. */
  title: string;
  /** Optional subtitle text displayed below the title. */
  subtitle?: string;
  /** When true, uses white text for dark background sections. */
  light?: boolean;
}

/**
 * Centered section heading with optional subtitle.
 */
export function SectionHeading({ title, subtitle, light }: SectionHeadingProps): React.JSX.Element {
  return (
    <div className={`landing-section-heading${light ? ' landing-section-heading--light' : ''}`}>
      <h2 className="landing-section-heading__title">{title}</h2>
      {subtitle && (
        <p className="landing-section-heading__subtitle">{subtitle}</p>
      )}
    </div>
  );
}
